import { useSentryKey } from '@/injectionKeys';
import { captureException, captureWarning } from '@/wabunka-src/common/utils/sentry';

export const useBaseSentry = () => {
  const captureWabunkaException = (e: Error) => {
    return captureException(e, 'wabunka');
  };

  const captureWabunkaWarning = (message: string) => {
    return captureWarning(message, 'wabunka');
  };

  return { captureWabunkaException, captureWabunkaWarning };
};

export const useSentry = () => {
  const injectedSentry = inject(useSentryKey) as typeof useBaseSentry;
  return injectedSentry();
};
